import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@components/ui/form";
import { ColorPicker } from "@components/ui/colorPicker";
import { SelectTipografia } from "@components/ui/SelectTipografia";
import type { CustomRenderer, FieldRendererProps } from "./FormBuilder";
import type { FieldValues } from "react-hook-form";
import { SelectClienteIntermedio } from "./SelectIntermediario";

export const colorRenderer = <
  TForm extends FieldValues = FieldValues,
>(): CustomRenderer<TForm> =>
  ({ name, label, control, required }: FieldRendererProps<TForm>) =>
    (
      <FormField
        control={control}
        name={name}
        render={({ field }) => (
          <FormItem>
            {label && <FormLabel required={required}>{label}</FormLabel>}
            <FormControl>
              <ColorPicker {...field} value={field.value ?? ""} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    );

export const selectFontRenderer = <
  TForm extends FieldValues = FieldValues,
>(): CustomRenderer<TForm> =>
  ({ name, label, control, required }: FieldRendererProps<TForm>) =>
    (
      <FormField
        control={control}
        name={name}
        render={({ field }) => (
          <FormItem>
            {label && <FormLabel required={required}>{label}</FormLabel>}
            <FormControl>
              <SelectTipografia
                value={field.value ?? ""}
                onChange={(v) => field.onChange(v)}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    );

export const selectIntermedioRender = <
  TForm extends FieldValues = FieldValues,
>(): CustomRenderer<TForm> =>
  ({ name, label, control, required }: FieldRendererProps<TForm>) =>
    (
      <FormField
        control={control}
        name={name}
        render={({ field }) => (
          <FormItem>
            {label && <FormLabel required={required}>{label}</FormLabel>}
            <FormControl>
              <SelectClienteIntermedio
                value={field.value ?? ""}
                onChange={(v) => field.onChange(v)}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    );
